export default __webpack_public_path__ + "static/media/team15.efae4d8e.JPG";